/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface RapportSearch
 */
export interface RapportSearch {
    /**
     * 
     * @type {number}
     * @memberof RapportSearch
     */
    moduleId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RapportSearch
     */
    isActif?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RapportSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RapportSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RapportSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RapportSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RapportSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RapportSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RapportSearch interface.
 */
export function instanceOfRapportSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RapportSearchFromJSON(json: any): RapportSearch {
    return RapportSearchFromJSONTyped(json, false);
}

export function RapportSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'moduleId': !exists(json, 'moduleId') ? undefined : json['moduleId'],
        'isActif': !exists(json, 'isActif') ? undefined : json['isActif'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RapportSearchToJSON(value?: RapportSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'moduleId': value.moduleId,
        'isActif': value.isActif,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

